<!--
  @Description 节假日基础设置
  @Date 2021-12-23
  @Author liushuo
-->
<template>
  <div>
    <vxe-grid
      ref="xTable"
      resizable
      :column-config="{ minWidth: '80px' }"
      :data="tableData"
      :toolbar-config="tableToolbar"
      @toolbar-button-click="toolbarButtonClickEvent"
      size="mini"
      :mouse-config="{ area: true }"
      :edit-rules="validRules"
      highlight-hover-row
      highlight-current-row
      :height="tableHeight"
      :columns="gridColumns"
      :edit-config="{
        trigger: 'dblclick',
        mode: 'cell',
        activeMethod: activeMethod
      }"
      :keyboard-config="{
        isArrow: true,
        isEnter: true,
        isTab: true,
        enterToTab: true,
        isClip: true,
        isEdit: true,
        editMethod: editMethod
      }"
    >
    </vxe-grid>
  </div>
</template>

<script>
export default {
  name: 'holidays',
  props: {
    searchFormVisible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      tableData: [],
      gridColumns: [
        { type: 'seq', width: 40 },
        {
          field: 'delete', title: '删除',
          visible: this.$parent.Authority.edit,
          width: '50', align: 'center', slots: { default: ({ row }) => { return [<i id="vxeDelete" class="el-icon-delete-solid" onClick={() => { this.removeRowForTable(row, this.$refs.xTable, this.$data) }} ></i>] } }
        },
        {
          title: '节假日名称',
          field: 'displayMember',
          editRender: { name: "input" }
        },
        {
          title: '排序', field: 'sort',
          editRender: { name: "input" }
        }
      ],
      // 正常状态下，需要加上表格距离card上下的margin
      topBottomMargin: 20,
      // tabel工具栏
      tableToolbar: {
        buttons: [
          { code: 'insertOne', name: '新增1行' },
          { code: 'insertTen', name: '新增10行' },
        ],
      },
      // 校验
      validRules: {
        displayMember: [
          { required: true, message: '请输入节假日名称', trigger: 'change' },
          {
            min: 0,
            max: 4,
            message: '节假日名称长度应在 0 到 4 个字符',
            trigger: 'change'
          }
        ],
        sort: [
          {
            validator: this.isInteger,
            validNumerical: this.validNumerical.nonNegative,
            trigger: 'change'
          }
        ]
      }
    }
  },
  created () {
    this.InitSettings()
    this.BindText()
  },
  methods: {
    InitSettings () {
      this.tableToolbar = {
        buttons: [
          { code: 'insertOne', name: '新增1行', disabled: !this.$parent.Authority.edit },
          { code: 'insertTen', name: '新增10行', disabled: !this.$parent.Authority.edit },
        ]
      }
    },
    async BindText () {
      if (!this.$parent.Authority.see) {
        this.$message.warning('您没有查看权限!')
        return
      }

      const { data: res } = await this.$http.get('Base/BCommonForCombox?setName=HolidayName')
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
      }
      // data 结构：{ detailList: [{ id, displayMember, sort}] }
      this.tableData = res.data.detailList
    },
    // table工具栏方法
    toolbarButtonClickEvent ({ code }) {
      switch (code) {
        case 'insertOne':
          this.insertEvent()
          break
        case 'insertTen':
          this.insertTenEvent()
          break
      }
    },
    // 新增一行
    insertEvent () {
      let record = {}
      this.$refs.xTable.insertAt(record, -1)
      // this.IfExistModify = true
    },
    // 新增10行
    insertTenEvent () {
      let record = {}
      for (var i = 0; i < 10; i++) {
        this.$refs.xTable.insertAt(record, -1)
      }
      // this.IfExistModify = true
    },
    // 修改(父组件触发)
    async updateData () {
      this.validEnter().then(async result => {
        if (result) {
          this.httpUpdate()
        }
      })
    },
    // 验证
    async validEnter () {
      let flag = true
      this.errIndex = []
      const errMap = await this.$refs.xTable.fullValidate(true).catch(errMap => errMap)
      if (errMap) {
        Object.values(errMap).forEach(errList => {
          errList.forEach(params => {
            let { row, columnIndex, rules } = params
            rules.forEach(() => {
              this.errIndex.push({
                _XID: row._XID,
                columnIndex: columnIndex
              })
            })
          })
        })
        if (this.errIndex.length > 0) {
          flag = false
        }
      }
      if (!flag) {
        this.$message.error('验证失败,请核对输入数据')
      }
      return flag
    },
    // 数据更新请求
    async httpUpdate () {
      let tableData = [...this.tableData]
      let insertRecords = this.$refs.xTable.getInsertRecords()
      let removeRecords = this.$refs.xTable.getRemoveRecords()
      let updateRecords = this.$refs.xTable.getUpdateRecords()
      tableData = []
      for (let item of insertRecords) {
        tableData.push(item)
      }
      for (let item of removeRecords) {
        item.id = item.id > 0 ? 0 - item.id : item.id
        tableData.push(item)
      }
      for (let item of updateRecords) {
        tableData.push(item)
      }
      tableData = this.removeArrayNull(tableData)

      const { data: res } = await this.$http.post('Base/BCommonForCombox', {
        'setName': 'HolidayName',
        'detailList': tableData
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
      }
      this.$message.success(res.data)
      this.BindText()
    },
    // cell激活控制
    activeMethod ({ column }) {
      if (column.editRender?.attrs?.disabled === true) {
        return false
      }
      if (!this.$parent.Authority.edit) {
        return false
      }
      return true
    },
    // cell编辑控制
    editMethod ({ row, column, $table }) {
      if (column.editRender?.attrs?.disabled === true) {
        return false
      }
      if (!this.$parent.Authority.edit) {
        return false
      }
      row[column.property] = null
      $table.setActiveCell(row, column.property)
      return true
    },
  },
  computed: {
    tableHeight () {
      let isSearchForm = this.searchFormVisible
      let isToolBar = true

      // 若有查询框，则共有四段 margin; 否则只有表格的两段 margin
      let tableMargin = isSearchForm ? this.heightConfig.mainMargin * 4 : this.heightConfig.mainMargin * 2
      return this.tableHeightComputed(tableMargin + this.topBottomMargin, isSearchForm, isToolBar)
    },
  }
}
</script>

<style lang="less" scoped>
</style>
